export default {
  // Modal Titles
  查看物料异常: "View Material Exception",
  编辑物料异常: "Edit Material Exception",
  登记物料异常标题: "Register Material Exception",

  // Table Column Titles
  处理状态: "Processing Status",
  物料编号: "Material Code",
  物料名称: "Material Name",
  物料类别: "Material Category",
  二级物料类别: "Secondary Material Category",
  物料进仓批号: "Warehouse Entry Number",
  供应商编号: "Supplier Code",
  "供应商名称（中文）": "Supplier Name (Chinese)",
  "供应商名称（英文）": "Supplier Name (English)",
  相关生产商名称: "Related Manufacturer Name",
  生产批号: "Production Batch",
  PO单号: "PO Number",
  发现日期: "Discovery Date",
  发起人: "Initiator",
  发起部门: "Initiating Department",
  操作: "Actions",

  // Status Values
  草稿: "Draft",
  待SCM提交意见: "Pending SCM Opinion",
  待QA提交意见: "Pending QA Opinion",
  待通知供应商: "Pending Supplier Notification",
  待供应商提供解决方案: "Awaiting Supplier Solution",
  解决方案审批中: "Solution Under Review",
  已驳回解决方案: "Solution Rejected",
  已完结: "Completed",
  未知: "Unknown",

  // Action Buttons
  编辑: "Edit",
  删除: "Delete",
  查看: "View",

  // Search Fields
  物料: "Material",
  供应商: "Supplier",
  请输入物料进仓批号: "Enter warehouse entry number",
  请输入物料名称: "Enter material name",
  请输入供应商名称: "Enter supplier name",
  请选择物料类别: "Select material category",
  请选择处理状态: "Select processing status",
  请选择发起人: "Select initiator",

  // Material Category Cascade Options
  生产物料: "Production Materials",
  非生产物料: "Non-Production Materials",
  API: "API",
  "輔料（Excipient）": "Excipient",
  包材: "Packaging Materials",
  RLD: "RLD",
  工程建设: "Engineering Construction",
  "设备/设施/仪器": "Equipment/Facilities/Instruments",
  MRO: "MRO",
  行政物资: "Administrative Supplies",
  IT物资: "IT Supplies",
  外包服务: "Outsourcing Services",

  // List Title and Buttons
  物料异常登记列表: "Material Exception Registration List",
  登记物料异常: "Register Material Exception",

  // Pagination
  共条数据: "Total {{totalCount}} records",

  // Form Labels
  员工姓名: "Employee Name",
  员工工号: "Employee ID",
  创建日期: "Creation Date",
  部门: "Department",
  岗位: "Position",
  邮箱: "Email",
  异常物料信息: "Exception Material Information",
  工厂: "Factory",
  请输入搜索物料编号: "Search by material code",
  请输入物料编号搜索: "Search by material code",
  请选择物料类别表单: "Select material category",
  请选择二级物料类别: "Select secondary material category",
  企业类型: "Enterprise Type",
  请选择相关生产商: "Select related manufacturer",
  发现异常日期: "Exception Discovery Date",
  请选择发现日期: "Select discovery date",
  涉及异常数量: "Involved Quantity",
  是否回仓冻结: "Warehouse Freeze",
  请选择通用: "Select option",
  回仓或冻结数量: "Freeze Quantity",
  请输入回仓或冻结数量: "Enter freeze quantity",
  额外工时涉及赔付: "Extra Hours Compensation",
  问题描述: "Issue Description",
  请输入问题描述: "Enter issue description",
  供应商标签照片: "Supplier Label Photo",
  请上传供应商标签照片: "Upload supplier label photo",
  相关照片或证明文件: "Related Photos or Supporting Documents",
  请上传相关照片或证明文件: "Upload related photos or supporting documents",
  决定退款换货: "Refund or Exchange Decision",
  请选择决定退款换货: "Select refund or exchange decision",
  质量诉求: "Quality Claim",
  是否需要调查反馈: "Investigation Required",
  期望解决日期: "Expected Resolution Date",
  请选择期望解决日期: "Select expected resolution date",
  诉求说明: "Claim Description",
  供应商解决方案: "Supplier Solution",
  备注说明: "Remarks",
  请输入备注说明表单: "Enter remarks",
  审批信息: "Approval Information",
  审批意见: "Approval Opinion",
  意见说明: "Opinion Description",
  同意: "Agree",
  驳回: "Reject",
  请输入意见说明: "Enter opinion description",

  // Form Placeholders
  请输入员工姓名: "Enter employee name",
  请输入员工工号: "Enter employee ID",
  请输入创建日期: "Enter creation date",
  请输入部门: "Enter department",
  请输入岗位: "Enter position",
  请输入邮箱: "Enter email",
  请输入供应商名称中文: "Enter supplier name (Chinese)",
  请输入供应商名称英文: "Enter supplier name (English)",
  由物料编号自动填写: "Auto-filled by material code",
  由物料进仓批号自动带出: "Auto-filled by warehouse entry number",

  // Option Values
  代理商: "Agent",
  生产商: "Manufacturer",
  是: "Yes",
  否: "No",
  退款: "Refund",
  换货: "Exchange",

  // Others
  单号: "Form Number",
  点击上传: "Click to Upload",

  // Messages
  请先选择公司和物料编号: "Please select company and material code first",
  获取批号信息失败: "Failed to get batch information",
  获取物料异常登记列表失败: "Failed to get material exception list",
  已登记: "Registered",
  提交失败: "Submission failed",
  已暂存: "Saved as draft",
  暂存失败: "Failed to save as draft",
  已通知供应商: "Supplier notified",
  通知供应商失败: "Failed to notify supplier",
};
